import makeStyles from '@mui/styles/makeStyles';

const usePlantDetailsStyles = makeStyles({
  root: {
    datePickerRoot: {
      '& .MuiInputBase-root': {
        // Custom styles for the input field
        // Example: changing the background color
        backgroundColor: '#e6e6e6',
      },
      '& .MuiPickersBasePicker-pickerView': {
        // Custom styles for the date picker
        // Example: changing the font size
        fontSize: '16px',
      },
      // Add more custom styles as needed
    },
    
  }
  
});

export default usePlantDetailsStyles;
